import {useLocation} from 'react-router-dom';

/** Slug статьи из URL /blog или /blog/my-post (только pathname). */
export function useBlogSlugFromUrl(): string {
  const {pathname} = useLocation();
  const match = pathname.match(/^\/blog\/?(.*)$/);
  if (!match) {
    return '';
  }

  const rest = match[1] ?? '';
  return rest ? decodeURIComponent(rest.split('/')[0]) : '';
}
